import { Logo, Stack, Text, useT } from "@bundle/ui";

/** First launch while the session or the workspace list loads (never shown when there's cached content). */
export function LoadingScreen() {
  const t = useT();
  return (
    <Stack grow align="center" justify="center" gap="4" background="bg.window" testID="loading-screen">
      <Logo variant="symbol" size="avatar.lg" />
      <Text color="text.secondary">{t("workspace.loading")}</Text>
    </Stack>
  );
}
